import { X } from "lucide-react";

/** "28s" countdown pill + close (✕) shown on every message. */
export default function MessageCountdown({ seconds, onClose, className = "" }) {
  return (
    <div className={`inline-flex shrink-0 items-center gap-1 ${className}`}>
      <span
        className="min-w-[2.25rem] rounded-full bg-black/5 px-2 py-0.5 text-center text-[11px] font-semibold tabular-nums text-slate-600"
        title={`Closes automatically in ${seconds} seconds`}
        aria-hidden
      >
        {seconds}s
      </span>
      <button
        type="button"
        onClick={onClose}
        className="rounded-lg p-1.5 text-slate-500 transition hover:bg-black/5 hover:text-slate-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-400"
        aria-label="Close"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
